/* import __COLOCATED_TEMPLATE__ from './standard-modal-footer.hbs.js'; */
import Component from '@ember/component';
import { assert } from '@ember/debug';
const ValidFooterButtonKeys = new Set(['action', 'isDisabled', 'isWarning', 'label']);
function validateConfig(config) {
  assert('Modal footer button label is required', config.label);
  assert('Modal footer button action is required', typeof config.action === 'function');
  for (const key in config) {
    assert(`${key} is not a valid modal footer button key`, ValidFooterButtonKeys.has(key));
  }
}

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'footer',
  classNames: ['dialog--modal__footer', 'modal-layout__footer'],
  classNameBindings: ['shouldCenterButtons:modal-layout__footer--centered'],
  isShowingSpinner: false,
  shouldCenterButtons: false,
  primaryButtonConfig: null,
  secondaryButtonConfig: null,
  tertiaryButtonConfig: null,
  didReceiveAttrs() {
    this._super();
    assert('primaryButtonConfig required', this.primaryButtonConfig);
    validateConfig(this.primaryButtonConfig);
    if (this.secondaryButtonConfig) {
      validateConfig(this.secondaryButtonConfig);
    }
    if (this.tertiaryButtonConfig) {
      validateConfig(this.tertiaryButtonConfig);
    }
  }
});